// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__bu6xV","messages":"Chat_messages__V3CMa","dateDivider":"Chat_dateDivider__Z5opo"};